<template>
  <div class="layout-block">
    <component
      :translation-context="translationContext"
      :config="config"
      :key="`${keyBase}-${type}`"
      ref="block"
      v-bind="blockOptions"
      v-if="localType"
      v-bind:is="localType"
    ></component>
  </div>
</template>
<script>
import Vue from "vue";
import TextArea from "./blocks/TextArea.vue";
import ImageBlock from "./blocks/Image.vue";
import HeaderBlock from "./blocks/Header.vue";
import Chart from "./blocks/Chart.vue";
import Button from "./blocks/Button.vue";
import CircleMeter from "./blocks/CircleMeter.vue";
import Signup from "./blocks/Signup.vue";
import ProgressBar from "./blocks/ProgressBar.vue";
import ConditionalContent from "./blocks/ConditionalContent";
import Utilities from "../../lib/Utilities.js";
import Delegator from "./blocks/Delegator.vue";
export default {
  props: {
    translationContext: { type: String, default: "" },
    type: { type: String, default: null },
    editable: { type: Boolean, default: false },
    config: { type: Object, default: () => {} }
  },
  provide() {
    return {
      blockTranslationContext: this.translationContext
    };
  },
  components: {
    TextArea,
    ImageBlock,
    HeaderBlock,
    Chart,
    CircleMeter,
    ProgressBar,
    Button,
    ConditionalContent,
    Delegator,
    Signup
  },
  data() {
    return {
      localType: null,
      blockOptions: {}
    };
  },
  computed: {
    keyBase() {
      return this.$vnode.key;
    },
    block() {
      return this.$refs.block;
    }
  },
  methods: {
    randomkey() {
      return Utilities.key();
    }
  },
  created() {
    this.localType = this.type;
  }
};
</script>
<style lang="scss" scoped></style>
